module.exports = __webpack_public_path__ + "static/challenge-79ec1303fac53a864ea20570ccab16ed.png";